import React, {useState} from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Loading } from "../../components/Ui";
import { FormationProvider } from "../../helpers/FormationContext";
import FormationDetails from "./FormationDetails";

const Formation = React.lazy(() => import("./Formations"));
const Overview = React.lazy(() => import("./Overview"));

const Formations = (props) => {
  const navigate = useNavigate();
    const routes = [
    { path: "/", element: Overview },
  ];

  return (
    <React.Fragment>
      <React.Suspense fallback={<Loading />}>
          <FormationProvider>
              <Routes>
                  <Route path="/" element={<Overview {...props}/>} />
                    <Route path="/:id" element={<FormationDetails {...props}/>} />
              </Routes>
          </FormationProvider>
      </React.Suspense>
    </React.Fragment>
  );
};

export default Formations;
